import React from 'react';
import PropTypes from 'prop-types';
import NavigationPanel from '@adsk/bim360-matrix-react-navigation-panel';
import Tabs from '@adsk/bim360-matrix-react-tabs';
import cx from 'classnames';

import './_AdminLayout.scss';

/**
 * Admin page layout component
 */
class AdminLayout extends React.PureComponent {
  render() {
    const adminLayoutClassName = cx('AdminLayout', this.props.className);
    const contentClassName = cx('AdminLayout__content', this.props.contentClassName);

    return (
      <div className={adminLayoutClassName}>
        {this.props.navigationPanelProps && (
          <NavigationPanel {...this.props.navigationPanelProps} />
        )}
        <div className="AdminLayout__page">
          <Tabs
            {...this.props.tabStripProps}
            className="AdminLayout__tabs"
            theme={Tabs.Themes.admin}
          />
          <div className={contentClassName}>{this.props.children}</div>
        </div>
      </div>
    );
  }
}

AdminLayout.propTypes = {
  /**
   * Selected admin tab content
   */
  children: PropTypes.node.isRequired,
  /**
   * Props for the navigation panel
   */
  navigationPanelProps: PropTypes.shape(NavigationPanel.propTypes),
  /**
   * props for the tab strip. Theme will be ignored
   */
  tabStripProps: PropTypes.shape(Tabs.propTypes).isRequired,
  /**
   * A custom className for the container element of the component
   */
  className: PropTypes.string,
  /**
   * Content element class name
   */
  contentClassName: PropTypes.string
};

export default AdminLayout;
